import React, { useState, useEffect } from 'react';
import { Boxes, Package, Layers } from 'lucide-react';
import api from '../../utils/api';
import DataTable from '../../components/ui/DataTable';
import { useAuth } from '../../context/AuthContext';

const StatTile = ({ icon: Icon, label, value }) => (
  <div className="zip-card p-5 flex items-center gap-4">
    <div className="w-11 h-11 rounded-xl bg-zip-red/10 border border-zip-red/20 flex items-center justify-center flex-shrink-0">
      <Icon size={20} className="text-zip-red" />
    </div>
    <div>
      <div className="text-2xl font-bold text-zip-text font-mono leading-none">{value}</div>
      <div className="text-xs text-zip-muted mt-1">{label}</div>
    </div>
  </div>
);

const ClientInventory = () => {
  const { user } = useAuth();
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/rack/stock-summary')
      .then((r) => {
        setRows(r.data.data || []);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const distinctItems = new Set(rows.map((r) => r.itemName)).size;
  const totalQty = rows.reduce((s, r) => s + (r.totalQty || 0), 0);

  const columns = [
    { label: 'Item', key: 'itemName', render: (r) => <span className="font-medium text-zip-text">{r.itemName}</span> },
    { label: 'Floor', key: 'floor', render: (r) => <span className="chip-blue">{r.floor || '—'}</span> },
    { label: 'Quantity', key: 'totalQty', render: (r) => <span className="font-mono text-zip-text font-semibold">{r.totalQty} {r.unit}</span> },
  ];

  return (
    <div className="space-y-5">
      <div className="zip-card px-5 py-4">
        <div className="text-sm text-zip-muted">
          Showing live stock for <span className="font-semibold text-zip-text">{user?.client?.name ?? 'your account'}</span> across all warehouses.
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatTile icon={Boxes}   label="Stock Lines"     value={loading ? '—' : rows.length} />
        <StatTile icon={Layers}  label="Distinct Items"  value={loading ? '—' : distinctItems} />
        <StatTile icon={Package} label="Total Quantity"  value={loading ? '—' : totalQty} />
      </div>

      {loading ? (
        <div className="zip-card p-5 space-y-3">
          {[...Array(5)].map((_, i) => <div key={i} className="h-10 skeleton rounded" />)}
        </div>
      ) : (
        <DataTable columns={columns} rows={rows} emptyText="No stock currently held for your account." />
      )}
    </div>
  );
};

export default ClientInventory;
